"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SalesOrder = exports.ItemSo = exports.SalesOrderItem = void 0;
const tslib_1 = require("tslib");
const base_models_1 = require("@integration/base-models");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
class SalesOrderItem extends base_models_1.Serializable {
}
exports.SalesOrderItem = SalesOrderItem;
tslib_1.__decorate([
    (0, class_validator_1.IsString)(),
    (0, base_models_1.Docs)({ example: '0123456789', description: "customer's account ID" }),
    tslib_1.__metadata("design:type", String)
], SalesOrderItem.prototype, "AccountID", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsString)(),
    (0, base_models_1.Docs)({ example: 'E_H_BZ', description: 'SAP code of the product' }),
    tslib_1.__metadata("design:type", String)
], SalesOrderItem.prototype, "ProductID", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsString)(),
    (0, base_models_1.Docs)({ example: '10', description: 'item number' }),
    tslib_1.__metadata("design:type", String)
], SalesOrderItem.prototype, "ItemNum", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsString)(),
    (0, base_models_1.Docs)({ example: '20', description: 'quantity' }),
    tslib_1.__metadata("design:type", String)
], SalesOrderItem.prototype, "Quantity", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsString)(),
    (0, base_models_1.Docs)({ example: '', description: 'object id' }),
    tslib_1.__metadata("design:type", String)
], SalesOrderItem.prototype, "SalesOrderId", void 0);
class ItemSo extends base_models_1.Serializable {
}
exports.ItemSo = ItemSo;
tslib_1.__decorate([
    (0, base_models_1.Docs)({ example: [], description: 'found results' }),
    (0, class_validator_1.IsArray)(),
    (0, class_transformer_1.Type)(() => SalesOrderItem),
    tslib_1.__metadata("design:type", Array)
], ItemSo.prototype, "results", void 0);
class SalesOrder extends base_models_1.Serializable {
}
exports.SalesOrder = SalesOrder;
tslib_1.__decorate([
    (0, class_validator_1.IsString)(),
    (0, base_models_1.Docs)({ example: '0123456789', description: "customer's account ID" }),
    tslib_1.__metadata("design:type", String)
], SalesOrder.prototype, "AccountID", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsString)(),
    (0, base_models_1.Docs)({ example: 'description', description: 'description of the sales order' }),
    tslib_1.__metadata("design:type", String)
], SalesOrder.prototype, "Description", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsString)(),
    (0, base_models_1.Docs)({ example: 'ZOEM', description: 'type of the process' }),
    tslib_1.__metadata("design:type", String)
], SalesOrder.prototype, "ProcessType", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsString)(),
    (0, base_models_1.Docs)({ example: '000660000002', description: 'business agreement ID' }),
    tslib_1.__metadata("design:type", String)
], SalesOrder.prototype, "BusinessAgreementID", void 0);
tslib_1.__decorate([
    (0, base_models_1.Docs)({ example: { results: [] }, description: 'item details' }),
    (0, class_transformer_1.Type)(() => ItemSo),
    tslib_1.__metadata("design:type", ItemSo)
], SalesOrder.prototype, "ItemSo", void 0);
